import {createSlice} from "@reduxjs/toolkit";

import {CurrentMakerSummaryFragment, CurrentUserSummaryFragment, UnreadCounts} from "~/api/generated";

import {resetAll} from "./global";

export interface UserState {
  impersonation: Boolean;
  maker: CurrentMakerSummaryFragment | null | undefined;
  user: CurrentUserSummaryFragment | undefined;
  unreadCounts: UnreadCounts | undefined;
  isSuccessfullyCreatedCompanyMessageVisible: boolean;
  makerHasDigitalProducts?: boolean;
  selectedStoreId: string | null;
}

const STORE_SESSION_KEY = "selectedStoreId";

const initialState: UserState = {
  impersonation: false,
  maker: undefined,
  user: undefined,
  unreadCounts: undefined,
  isSuccessfullyCreatedCompanyMessageVisible: false,
  makerHasDigitalProducts: undefined,
  selectedStoreId: sessionStorage.getItem(STORE_SESSION_KEY),
};

export const UserSlice = createSlice({
  name: "user",
  initialState,
  extraReducers: (builder) => builder.addCase(resetAll, () => initialState),
  reducers: {
    setImpersonation: (state, action) => {
      state.impersonation = action.payload;
    },
    setMaker: (state, action) => {
      state.maker = action.payload;
    },
    setUser: (state, action) => {
      state.user = action.payload;
    },
    setUnreadCounts: (state, action) => {
      state.unreadCounts = action.payload;
    },
    showSuccessfullyCreatedCompanyMessage: (state) => {
      state.isSuccessfullyCreatedCompanyMessageVisible = true;
    },
    hideSuccessfullyCreatedCompanyMessage: (state) => {
      state.isSuccessfullyCreatedCompanyMessageVisible = false;
    },
    setMakerHasDigitalProducts: (state, action) => {
      state.makerHasDigitalProducts = action.payload;
    },
    setSelectedStoreId: (state, action) => {
      state.selectedStoreId = action.payload;
    },
  },
});

export const UserActions = UserSlice.actions;

export default UserSlice.reducer;
